import { GendersEnum } from '../../enums/genders.enum';
import { IsNotEmpty, IsString } from 'class-validator';

export class OtherGenderDto {
    @IsNotEmpty()
    @IsString()
    name: string;

    @IsNotEmpty()
    @IsString()
    treatAsGenderId: GendersEnum;
}
